/**
 * Normalize list item strings that are displayed with bullets.
 * Display components add "• " before each item, so we must not store bullets in the data.
 * Strips leading bullet chars (•, -, *, etc.) to avoid double bullets when rendering.
 */
export function stripLeadingBullet(s: string): string {
  if (!s || typeof s !== 'string') return '';
  return s.replace(/^[\s•\-*]\s*/, '').trim();
}

/**
 * Normalize an array of list items by stripping leading bullets from each.
 * Filters out empty strings after stripping.
 */
export function normalizeListItems(items: string[]): string[] {
  if (!Array.isArray(items)) return [];
  return items.map(stripLeadingBullet).filter((s) => s.length > 0);
}
